import * as React from "react";
import { Link } from "react-router-dom";

import { AspectRatio, SvgSprite } from ".";

interface HeaderProps {
  adminApplicationUrl: string;
}

export const Header: React.FC<HeaderProps> = ({ adminApplicationUrl }) => {
  if (!adminApplicationUrl) {
    throw Error(
      "No adminApplicationUrl passed to <Header />. This should be the url to either au/nz admin url"
    );
  }

  return (
    <header>
      <div className="container py-3">
        <div className="row align-items-center justify-content-between mx-n2">
          <div className="col-auto flex-grow-1 px-2">
            <Link
              css={`
                max-width: 249px;
                max-height: 48px;
              `}
              className="text-reset d-block"
              to={{
                pathname: "/",
                state: {
                  resetSearch: true,
                },
              }}
            >
              <AspectRatio width={249} height={48}>
                <SvgSprite id="logos:seekvolunteer" />
              </AspectRatio>
              <span className="sr-only">SEEK Volunteer</span>
            </Link>
          </div>
          <div className="px-2 ml-auto text-right">
            <a
              href={`${adminApplicationUrl}/register`}
              className="btn btn-forward text-nowrap border-0"
            >
              Find Volunteers
            </a>
          </div>
        </div>
      </div>
    </header>
  );
};
